import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import { IconHeadphones, IconQuestionMark, IconTruckDelivery } from '@tabler/icons-react';

const FAQ = () => {
    const [activeCategory, setActiveCategory] = useState('delivery');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const categories: any = {
        delivery: {
            title: 'ارسال و دریافت سفارش',
            questions: [
                {
                    id: 'collapseOne',
                    question: 'سفارشم آماده ارسال است و گزینه ارسال با پیک را انتخاب کردم. کالا دقیقا چه زمانی ارسال می‌شود؟',
                    answer: 'تمامی کالاهای ارسالی بر اساس منطقه مشتری ارسال می‌گردد. کارشناسان نیم ساعت قبل از ارسال با مشتریان عزیز تماس خواهند گرفت.'
                },
                {
                    id: 'collapseTwo',
                    question: 'امکان ارسال دو سفارش جداگانه به طور همزمان وجود دارد؟',
                    answer: 'مشتریان محترم می‌توانند با ارتباط با مرکز تماس خواسته خود را اعلام در صورت تایید مشاوران و نوع محصول امکان‌پذیر است.'
                },
                {
                    id: 'collapseThree',
                    question: 'آیا می‌توان سفارش خود را در روز و ساعت دلخواه تحویل گرفت؟',
                    answer: 'درحال حاضر این امر امکان‌پذیر نمی‌باشد.'
                },
                {
                    id: 'collapseFour',
                    question: 'آیا برای تحویل کالا مدارکی نیاز است؟',
                    answer: 'همراه داشتن کارت شناسایی معتبر دارای کد ملی شخص و همچنین به همراه داشتن شماره سفارش الزامی است.'
                },
                {
                    id: 'collapseFive',
                    question: 'شرایط و هزینه ارسال در تهران و شهرستان چگونه است؟',
                    answer: 'هزینه ارسال در تهران از طریق پیک اختصاصی آکبند وابسته به موقعیت مکانی متغیر می‌باشد. هزینه ارسال توسط تیپاکس و ماهکس به صورت پس‌کرایه در زمان تحویل کالا از مشتریان اخذ می‌گردد.'
                },
                {
                    id: 'collapseSix',
                    question: 'سفارشات ارسالی توسط تیپاکس یا ماهکس را چگونه پیگیری کنم؟',
                    answer: 'پس از تحویل محصول به تیپاکس یا ماهکس یک کد رهگیری برای مشتریان پیامک می‌گردد که توسط آن امکان پیگیری برای مشتری وجود دارد.'
                },
                {
                    id: 'collapseSeven',
                    question: 'آیا امکان تحویل حضوری سفارش وجود دارد؟',
                    answer: 'بله. پس از پردازش سفارش همکاران واحد پردازش سفارشات با شما تماس گرفته و می‌توانید پس از هماهنگی لازم به آدرس فروشگاه حضوری و یا دفتر مرکزی مراجعه نمایید.'
                },
                {
                    id: 'collapseEight',
                    question: 'مدت زمان ارسال کالای خریداری شده چقدر است؟',
                    answer: 'در صورت ثبت و تایید نهایی و پرداخت هزینه طی مدت زمان ۴۸ الی ۷۲ ساعت کاری آماده‌سازی کالا صورت پذیرفته و پس از آن از روش انتخابی مشتریان ارسال کالا انجام خواهد شد.'
                }
            ]
        },
        general: {
            title: 'سوالات عمومی',
            questions: [
                {
                    id: 'collapseGeneralOne',
                    question: 'پس از نهایی شدن ثبت سفارش و پرداخت وجه، آیا امکان تغییر در نوع محصول (رنگ و نحوه ارسال) وجود دارد؟',
                    answer: 'خیر'
                },
                {
                    id: 'collapseGeneralTwo',
                    question: 'آیا امکان مشاوره حضوری وجود دارد؟',
                    answer: 'بله.'
                },
                {
                    id: 'collapseGeneralThree',
                    question: 'نحوه فعال‌سازی گارانتی چگونه است؟',
                    answer: 'تمامی کالاها دارای گارانتی فعال بوده و برای بررسی مدت اعتبار گارانتی کالا لازم است به وب‌سایت شرکت‌های گارانتی کننده مراجعه نمایید.'
                },
                {
                    id: 'collapseGeneralFour',
                    question: 'شرایط مرجوعی کالا چیست؟',
                    answer: 'مشتریان محترم می‌توانند حداکثر تا هفت روز از زمان ثبت سفارش، سفارش خود را مرجوع و یا تعویض نمایند. توجه داشته باشید که کالای مورد نظر باید در وضعیت پلمب باشد که این موضوع لازم است مورد تایید کارشناسان آکبند قرار گیرد.'
                },
                {
                    id: 'collapseGeneralFive',
                    question: 'عودت وجه پس از لغو سفارش به چه صورت می‌باشد؟',
                    answer: 'برای بازگشت وجه مشتری می‌تواند اطلاعات حساب خود را از طریق مرکز تماس به شرکت اعلام نموده و مبلغ مورد نظر طی ۷۲ ساعت کاری به حساب شخص واریز می‌گردد.'
                },
                {
                    id: 'collapseGeneralSix',
                    question: 'هنوز هزینه مرجوعی به حساب واریز نشده است. چه اقدامی انجام دهم؟',
                    answer: 'در صورتی که بیش از ۷۲ ساعت کاری از زمان ثبت درخواست گذشته است، از طریق تماس پیگیری نمایید.'
                },
                {
                    id: 'collapseGeneralSeven',
                    question: 'محصولات آکبند دارای گارانتی می‌باشد؟',
                    answer: 'اطلاعات گارانتی هر محصول در قسمت جزئیات محصول در سایت آکبند وجود دارد.'
                },
                {
                    id: 'collapseGeneralEight',
                    question: 'آیا از یک محصول می‌توان به تعداد خریداری نمود یا محدودیت تعدادی وجود دارد؟',
                    answer: 'با توجه به سیاست‌های آکبند، در برخی از موارد تنها می‌توان یک عدد از هر نوع محصول را خریداری نمود.'
                },
                {
                    id: 'collapseGeneralNine',
                    question: 'آیا پردازنده‌های (CPU) بدون باکس، گارانتی یا مهلت تست دارند؟',
                    answer: 'به طور کلی پردازنده‌ها (CPU) دارای گارانتی نبوده و تنها هفت روز مهلت تست دارند.'
                },
                {
                    id: 'collapseGeneralTen',
                    question: 'در سیستم اسمبل شده کارت گرافیک جدا ارسال شده است. دلیل این موضوع چیست؟ آیا اسمبل انجام نشده؟',
                    answer: 'در سیستم‌های کامل سفارش داده شده و اسمبل شده توسط آکبند، تمامی فرآیند اسمبل ابتدا به صورت کامل انجام می‌شود، سپس به علت حساس بودن کارت گرافیک پس از تست کامل قطعات، این قطعه جدا و به‌صورت مجزا ارسال می‌گردد تا از وارد شدن آسیب به کارت گرافیک جلوگیری شود.'
                },
                {
                    id: 'collapseGeneralEleven',
                    question: 'کد سفارش و یا شماره سریال کالا را چگونه پیدا کنم؟',
                    answer: 'شماره سفارش از طریق پیام کوتاه بر روی شماره تلفن همراهی که مشتری با آن در آکبند ثبت‌نام نموده است ارسال می‌گردد. همچنین با مراجعه به حساب کاربری در قسمت «سفارش‌های من» امکان مشاهده کد سفارش وجود دارد. شماره سریال کالا بر روی جعبه یا محصول درج شده و عموما با کاراکترهایی مانند serial، SN، S/N مشخص شده است. همچنین معمولا در کنار آن یک بارکد نیز وجود دارد.'
                },
                {
                    id: 'collapseGeneralTwelve',
                    question: 'چطور در حساب کاربری شماره کارت بانکی شخصی خود را وارد کنم؟',
                    answer: 'وارد حساب کاربری خود شوید، سپس با کلیک روی گزینه مشخصات فردی می‌توانید اطلاعات مربوط به شماره کارت بانکی را وارد نمایید.'
                },
                {
                    id: 'collapseGeneralThirteen',
                    question: 'چطور در حساب کاربری، مشخصاتم را ویرایش کنم؟',
                    answer: 'وارد حساب کاربری خود شوید، سپس با کلیک روی گزینه مشخصات فردی می‌توانید اطلاعات را ویرایش نمایید.'
                }
            ]
        },
        order: {
            title: 'نحوه ثبت و پیگیری سفارش',
            questions: [
                {
                    id: 'collapseOrderOne',
                    question: 'سفارشم را به صورت اینترنتی پرداخت نمودم، وجه از حسابم کسر شده اما پرداخت سفارشم تایید نشده است؟',
                    answer: 'مشتریان محترم می‌توانند با تماس این مورد را پیگیری نمایند.'
                },
                {
                    id: 'collapseOrderTwo',
                    question: 'امکان درخواست فاکتور رسمی در سایت به چه صورت است؟',
                    answer: 'مشتریان محترم می‌توانند درخواست خود را در تماس با مرکز تماس آکبند اعلام نمایند. لازم به ذکر است که اطلاعات کامل شخص حقیقی و حقوقی جهت صدور فاکتور دریافت خواهد شد.'
                },
                {
                    id: 'collapseOrderThree',
                    question: 'به همراه کالا فاکتور معمولی یا رسمی ارسال می‌شود؟',
                    answer: 'در صورت درخواست مشتری فاکتور رسمی ارسال می‌گردد.'
                },
                {
                    id: 'collapseOrderFour',
                    question: 'فاکتور سفارش را چطور دریافت کنم؟',
                    answer: 'پس از تحویل کالا، می‌توانید با مراجعه به حساب کاربری خود، آخرین سفارش‌ها را مشاهده کرده و با کلیک روی مشاهده جزئیات، نسبت به دریافت فاکتور و چاپ آن اقدام کنید.'
                },
                {
                    id: 'collapseOrderFive',
                    question: 'چرا مبلغ از حسابم کسر شده، اما سفارش ثبت نشده است؟',
                    answer: 'عموما دلیل این اتفاق اختلال مربوط به درگاه بانکی است. درصورت بروز این مشکل، مبلغ پرداخت شده طی ۷۲ ساعت به حساب بانکی شما بازگردانده می‌شود.'
                }
            ]
        }
    };

    return (
        <>
            <section className="container py-5">
                <div className="row gx-4">
                    <div className="col-md-3 ">
                        <div className="category position-sticky" style={{ top: '170px' }}>
                            <div
                                className={`card card-body w-100 mb-3 ${activeCategory === 'delivery' ? 'text-site fw-bold border-site' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveCategory('delivery')}
                            >
                                <p className="mb-0">
                                    <IconTruckDelivery className='me-2' />
                                    ارسال و دریافت سفارش
                                </p>
                            </div>
                            <div
                                className={`card card-body w-100 mb-3 ${activeCategory === 'general' ? 'text-site fw-bold border-site' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveCategory('general')}
                            >
                                <p className="mb-0">
                                    <IconQuestionMark className='me-2' />
                                    سوالات عمومی
                                </p>
                            </div>
                            <div
                                className={`card card-body w-100 ${activeCategory === 'order' ? 'text-site fw-bold border-site' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveCategory('order')}
                            >
                                <p className="mb-0">
                                    <IconHeadphones className='me-2' />
                                    نحوه ثبت و پیگیری سفارش
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-9">
                        <div className="accordion" id="accordionExample">
                            {categories[activeCategory].questions.map((item: any, index: any) => (
                                <div className="accordion-item" key={item.id}>
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button bg-white ${index === 0 ? 'fw-bold' : 'collapsed fw-bold'}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#${item.id}`}
                                        >
                                            {item.question}
                                        </button>
                                    </h2>
                                    <div
                                        id={item.id}
                                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body">{item.answer}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQ;